export enum EDistrict {
  DOLNOSLASKIE = 0,
  KUJAWSKO_POMORSKIE = 1,
  LUBELSKIE = 2,
  LUBUSKIE = 3,
  LODZKIE = 4,
  MALOPOLSKIE = 5,
  MAZOWIECKIE = 6,
  OPOLSKIE = 7,
  PODKARPACKIE = 8,
  PODLASKIE = 9,
  POMORSKIE = 10,
  SLASKIE = 11,
  SWIETOKRZYSKIE = 12,
  WARMINSKO_MAZURSKIE = 13,
  WIELKOPOLSKIE = 14,
  ZACHODNIOPOMORSKIE = 15
}
